import { API_ENDPOINTS, getApiUrl } from '../config/api';
import { ApiError } from './errors';

// Keep HTTP validators with their browser cache entry. no-cache revalidates before
// reuse, or fetches a fresh representation when that entry is absent.
async function read(path, signal) {
  const response = await fetch(getApiUrl(path), {
    signal, credentials: 'omit', cache: 'no-cache',
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    const failure = new ApiError('Public content is unavailable.', {
      status: response.status, code: error.code, fieldErrors: error.field_errors,
    });
    failure.retryAfter = response.headers?.get('Retry-After');
    throw failure;
  }
  const data = await response.json();
  if (data.contractVersion !== 1) throw new Error('Unsupported public content version.');
  return data;
}
const query = (values) => `?${new URLSearchParams(values)}`;
export const portfolioService = {
  bootstrap: (locale = 'en', signal) => read(API_ENDPOINTS.portfolio.bootstrap + query({ locale }), signal),
  material: (id, locale, signal) => read(API_ENDPOINTS.portfolio.material(id) + query({ locale }), signal),
  section: (id, sectionId, locale, signal) => read(
    API_ENDPOINTS.portfolio.section(id, sectionId) + query({ locale }), signal),
  gallery: (id, locale, cursor, signal) => read(
    API_ENDPOINTS.portfolio.gallery(id) + query({ locale, ...(cursor ? { cursor } : {}) }), signal),
  async question(id, payload, signal) {
    const response = await fetch(getApiUrl(API_ENDPOINTS.portfolio.questions(id)), {
      method: 'POST', credentials: 'omit', signal,
      headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
      const error = new ApiError('Question could not be answered.', {
        status: response.status, code: data.code, fieldErrors: data.field_errors,
      });
      error.retryAfter = response.headers?.get('Retry-After');
      throw error;
    }
    return data;
  },
};
